import axios from 'axios';

export async function getVaOutagePublic() {
  const res = await axios.get('/public/va-outage');
  // controller returns { statusCode, body } normally; normalize here
  const data = res.data && res.data.body ? res.data.body : res.data;
  return data;
}

export async function getVaOutageAdmin() {
  const res = await axios.get('/intake/va-outage');
  return res.data;
}

export async function setVaOutageAdmin(isOutage) {
  const res = await axios.post('/intake/va-outage', { isOutage });
  return res.data;
}


